import ModusServiceModel from "../ModusServiceModel";
import ResultEventModel from "./ResultEventModel";
import ResultNutrientRecommendationCollection from "@/collections/modus/ResultNutrientRecommendationCollection";
import ResultRecommendationCollection from "@/collections/modus/ResultRecommendationCollection";

export default class ResultRecommendationModel extends ModusServiceModel {
  modelName() {
    return 'result-recommendations';
  }
  icon() {
    return 'poll';
  }
  defaults() {
    return {
      id: null,
      result_event_id: null,
      result_event: null,
      identifier: null,
      name: null,
      expiration: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_nutrient_recommendations: {},
      result_recommendations: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_event_id: (val) => (this.nullStringMutator(val)),
      identifier: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      expiration: (val) => (this.nullStringMutator(val)),
      position: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getResultEvent() {
    return this.getRelatedModel(ResultEventModel, 'result_event');
  }
  getResultNutrientRecommendations() {
    return this.getRelatedCollection(new ResultNutrientRecommendationCollection(), 'result_nutrient_recommendations');
  }
  getResultRecommendations() {
    return this.getRelatedCollection(new ResultRecommendationCollection(), 'result_recommendations');
  }
}
